import React from 'react'
import clsx from 'clsx'

export interface LoaderProps {
  size?: 'sm' | 'md' | 'lg'
  variants?: 'primary' | 'secondary' | 'ternary'
  className?: string
}

function Loader(props: LoaderProps): JSX.Element {
  const { size = 'md', variants = 'primary', className } = props

  const cn = clsx('loader', `loader--${size}`, `loader--${variants}`, className)

  return <div className={cn} data-testid='loader' />
}

export default Loader
